module.exports = __webpack_public_path__ + "img/italian-salad-1.a41163c6.jpg";